import React, { createContext, useContext, useState, ReactNode } from "react";

/** Optional values to pre-fill the Add Doctor modal (e.g. when an admin starts a
 *  Doctor from the Add Staff flow and gets redirected here). */
export interface AddDoctorPrefill {
  name?: string;
  email?: string;
}

interface AddDoctorContextType {
  isAddDoctorModalOpen: boolean;
  addDoctorPrefill: AddDoctorPrefill | null;
  openAddDoctorModal: (prefill?: AddDoctorPrefill) => void;
  closeAddDoctorModal: () => void;
}

const AddDoctorContext = createContext<AddDoctorContextType | undefined>(undefined);

export const AddDoctorProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isAddDoctorModalOpen, setIsAddDoctorModalOpen] = useState(false);
  const [addDoctorPrefill, setAddDoctorPrefill] = useState<AddDoctorPrefill | null>(null);

  const openAddDoctorModal = (prefill?: AddDoctorPrefill) => {
    setAddDoctorPrefill(prefill ?? null);
    setIsAddDoctorModalOpen(true);
  };
  const closeAddDoctorModal = () => {
    setIsAddDoctorModalOpen(false);
    setAddDoctorPrefill(null);
  };

  return (
    <AddDoctorContext.Provider
      value={{ isAddDoctorModalOpen, addDoctorPrefill, openAddDoctorModal, closeAddDoctorModal }}
    >
      {children}
    </AddDoctorContext.Provider>
  );
};

export const useAddDoctor = () => {
  const context = useContext(AddDoctorContext);
  if (context === undefined) {
    throw new Error("useAddDoctor must be used within an AddDoctorProvider");
  }
  return context;
};
